import { find, get } from 'lodash'
import { useEffect, useState } from 'react'

import HttpRequest from '@/config/axios.config'
import { quantity_breakdown_types_obj } from '../../constant/quanity_breakdown'

export const getProductStatusTaskId = () => {}

export const getProductStatusProgress = async ({ orderId, sectionId }) => {
  return HttpRequest.get(
    `/sections/${sectionId}/product-status/orders/${orderId}`
  )
}

export const transfromViewOrderProperty = (hero: any[]) => {
  const [totalQuantity, settotalQuantity] = useState(null)
  const [deliveryDate, setdeliveryDate] = useState<any | any>(null)

  useEffect(() => {
    settotalQuantity(
      get(
        find(
          get(
            find(hero, { name: 'delivery date' }),
            'orders.property_value.values'
          ),
          {
            key: 'totalQuantity',
          }
        ),
        'value',
        null
      )
    )
    setdeliveryDate(
      get(find(hero, { name: 'delivery date' }), 'orders.to_be_delivered_at')
    )
  }, [hero])

  return {
    totalQuantity,
    deliveryDate,
  }
}

export const transfromTotalOrder = (orderQuantity, type?: any) => {
  const {
    TOTAL_QUANTITY_ONLY,
    BY_DESTINATION,
    CUSTOM_ITEM,
    BY_COLOR_AND_SIZE,
  } = quantity_breakdown_types_obj
  try {
    let totalQty = 0
    switch (type) {
      case TOTAL_QUANTITY_ONLY:
        return orderQuantity
      case BY_DESTINATION:
      case CUSTOM_ITEM:
        for (const [, value] of Object.entries(orderQuantity) as any) {
          totalQty += parseFloat(value?.quantity as any)
        }
        return totalQty
      case BY_COLOR_AND_SIZE:
        for (const [, value] of Object.entries(orderQuantity)) {
          for (const [, myValue] of Object.entries(value)) {
            totalQty += parseFloat(myValue)
          }
        }
        return totalQty
      default:
        return 0
    }
  } catch (error) {
    return 0
  }
}
